import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class QualityCertificateMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.qualityCertificate.qualityCertificateMapperError"));

        Object.setPrototypeOf(this, QualityCertificateMapperError.prototype);
    }
}